// extracted by mini-css-extract-plugin
export default {"calculatorResults":"results--calculatorResults","calculatorResultsCheck":"results--calculatorResultsCheck","calculatorRecalc":"results--calculatorRecalc"};